let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("akscf")).then(() => parcelRequire('chgNc'));